import React from 'react';
import ACard from '../../components/ACard';
import Box from '../../components/Box';
import Typography from '../../components/Typography';
import Widget from '../../components/Widget';
import { IClassNames } from '../../hooks/classNames.hooks';
import useConfig from '../../hooks/config.hooks';
import { translate, translateHTML } from '../../i18n';
import ACardEmptyAlert from '../ACard/ACardEmptyAlert';
import ACardSummary from '../ACard/ACardSummary';

interface ACardWidgetProps extends IClassNames {
  card?: Api.UserACard;
}

const ACardWidget: React.FC<ACardWidgetProps> = ({ card, ...props }) => {
  const { ACARD_INFO_URL } = useConfig();

  return (
    <Widget
      title="acard.title"
      description="acard.description"
      ctaText={card && 'dashboard.widget.acard.cta'}
      ctaTo={card && '/a-kaart'}
      unstyled
      {...props}
    >
      <div className="u-margin-top">
        <ACardEmptyAlert card={card} />

        <Box>
          <ACard number={card?.cardNumber} />
          {!card && (
            <div className="u-margin-top">
              <Typography variant="h3" as="h6" classNames="u-margin-bottom">
                {translate('acard.empty.title')}
              </Typography>

              {translateHTML('acard.empty.body')}

              <a
                href={ACARD_INFO_URL}
                className="a-button a-button--block u-margin-top"
                target="_blank"
              >
                {translate('acard.empty.cta')}
              </a>
            </div>
          )}
        </Box>
        {card && <ACardSummary card={card} />}
      </div>
    </Widget>
  );
};

export default ACardWidget;
